import { render, staticRenderFns } from "./FormAssessment.vue?vue&type=template&id=7468eb89"
import script from "./FormAssessment.vue?vue&type=script&lang=js"
export * from "./FormAssessment.vue?vue&type=script&lang=js"
import style0 from "./FormAssessment.vue?vue&type=style&index=0&id=7468eb89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports